'use strict'

import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import classnames from 'classnames'

import './FAQLists.scss'

class FAQList extends PureComponent {
  render () {
    const { title, faqs } = this.props
    const ccn = 'top-faqs'
    const parentClassName = classnames([ccn], { [ccn + '--inverse']: this.props.inverse })

    if (!this.props.faqs) return null
    return (
      <div className={parentClassName}>
        <h4 className={ccn + '__title h1'}>{title}</h4>
        <ul className={ccn + '__lists'}>
          {
            faqs.map((faq, i) => {
              return (
                <li className={ccn + '__list'} key={i}>
                  <Link className={ccn + '__link ' + ccn + '__link--' + i} to={faq.url}>{faq.question}</Link>
                </li>
              )
            })
          }
        </ul>
      </div>
    )
  }
}

FAQList.propTypes = {
  title: PropTypes.string,
  faqs: PropTypes.array,
  inverse: PropTypes.bool
}

export default FAQList
